import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  enjoyText: {
    textAlign: 'left',
    marginTop: 5,
    marginBottom: 10,
  },
  container: {justifyContent: 'flex-start', marginTop: 10},
  imagesContainer: {
    justifyContent: 'flex-start',
    width: '100%',
    flexWrap: 'wrap',
  },
  imageTouchable: {
    marginRight: 8,
    marginBottom: 8,
  },
  imageStyle: {
    height: 130,
    width: 114,
    borderRadius: 5,
  },
  imageVanStyle: {
    height: 55,
    width: 55,
    marginRight: 13,
  },
  alignText: {textAlign: 'left'},
  flexStyle: {flex: 1},
});
